/** @jsxRuntime classic */
/** @jsx jsx */
import { Container, Link, P, Title } from '@bottlebooks/gatsby-theme-base/src';
import EventBanner from '@bottlebooks/gatsby-theme-event/src/components/Event/EventBanner';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function FourOhFourPage({ data, pageContext }) {
  const { bottlebooks } = data;
  return (
    <Layout locale={pageContext.locale}>
      <EventBanner event={bottlebooks.event} withOverlay={false} />
      <Container>
        <Title sx={{ marginY: 3 }}>
          <Trans>Page not found</Trans>
        </Title>
        <P>
          <Trans>We couldn't find what you were looking for.</Trans>
        </P>
        <P>
          <Trans>
            Try a search or start over at the <Link to="/">home page.</Link>
          </Trans>
        </P>
      </Container>
    </Layout>
  );
}

export const query = graphql`
  query FourOhFourPage(
    $locale: Bottlebooks_ContentLocale!
    $collectionId: ID!
  ) {
    bottlebooks {
      event(eventId: $collectionId, locale: $locale) {
        name
        ...bb_EventBanner
      }
    }
  }
`;
